<template>
	<div>
		<button type="button" class="btn btn-primary" v-on:click="getLogs()" v-tooltip="'Actualizar contacto'">
			<i class="material-icons">refresh</i>
		</button>
		<div v-if="!loading">
			<div class="table-responsive" v-if="logsdata.length>0">
				<table class="table table-striped">
					<thead>
						<tr>
							<th>Fecha</th>
							<th v-if="!tipoDF">Tipo</th>
							<th v-if="!code">Código</th>
							<th>Estado</th>
							<th>Mensaje</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(log, index) in logsdata">
							<th>{{log.FECHA_CREACION}}</th>
							<th v-if="!tipoDF">{{log.TIPO}}</th>
							<th v-if="!code">{{log.CODIGO_TIPO}}</th>
							<td>
								<span class="badge badge-success" v-if="log.ESTADO == 1">
									Éxito
								</span>
								<span class="badge badge-danger" v-else>
									Error
								</span>
							</td>
							<td>{{parseJSON(log.RESPUESTA)}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="text-center" v-else>
				No hay datos
			</div>
			<paginacion
				:pagination="logs"
				@paginate="getLogs()"
				:offset="4">
			</paginacion>
		</div>
		<div v-else>
			<preloader></preloader>
			Cargando...
		</div>
	</div>
</template>
<script type="text/javascript">
	export default {
		props: ['tipo', 'codigo'],

		data(){
			return {
				loading: false,
				logs: {
		            total: 0,
		            per_page: '',
		            data: [],
		            from: 1,
		            to: 0,
		            current_page: 1
		        },
			}
		},

		mounted(){
			this.getLogs()
		},

		methods: {
			getLogs: function(validatePage = false){
				this.loading = true;
				var url = 'api/webhook/logs';
				if (validatePage) {
					this.grupos.current_page = 1
				}

				axios.get(url, {
					params: {
						page: this.logs.current_page,
						per_page: this.logs.per_page,
						CODIGO_TIPO: this.code,
						TIPO: this.tipoDF
					}
				})
				.then(response => {
					this.logs = response.data;
				}).catch(error => {
					console.log(error.response);
				}).then(()=>{
					this.loading = false;
				});
			},

			parseJSON(string) {
				return string.replace(/\\/g, '')
			}
		},

		computed: {
			code(){
				return this.codigo || 0
			},

			tipoDF(){
				return this.tipo || 0
			},

			logsdata(){
				return this.logs.data || []
			}
		}
	}
</script>